import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polyline
    {...props}
    points="13.75 37.24 29.62 52.03 57.23 52.03 53.88 34.75 29.54 11.8"
  />
);

export const AvatarArtworkIronGiant = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.ironGiant}
    renderShadow={renderShadow}
  >
    <g
      style={{
        transform: 'scale(1.05) translate(-1px, -1px)',
      }}
    >
      <path
        d="M34.44,20.2v15.53H13.29v-15.53c0-5.84,4.71-10.57,10.53-10.62h.09c5.82.05,10.53,4.78,10.53,10.62Z"
        fill="#9aa2b5"
      />
      <ellipse
        cx="18.76"
        cy="20.95"
        rx="3.52"
        ry="3.97"
        fill="none"
        stroke="#7b8291"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <ellipse
        cx="18.76"
        cy="21.17"
        rx="2.17"
        ry="2.46"
        fill="#fbf7c9"
        stroke="#effbd3"
        strokeMiterlimit="10"
      />
      <ellipse
        cx="28.99"
        cy="20.95"
        rx="3.52"
        ry="3.97"
        fill="none"
        stroke="#7b8291"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <ellipse
        cx="28.99"
        cy="21.17"
        rx="2.17"
        ry="2.46"
        fill="#fbf7c9"
        stroke="#effbd3"
        strokeMiterlimit="10"
      />
      <polygon
        points="29.54 39.44 29.54 39.47 29.44 39.47 29.54 39.44"
        fill="#7b8291"
      />
      <path
        d="M10.88,23.86l.77.17c.2.04.38-.14.38-.39v-1.99c0-.25-.18-.43-.38-.39l-.77.17c-.15.03-.27.2-.27.39v1.65c0,.19.11.35.27.39Z"
        fill="#7b8291"
      />
      <path
        d="M36.87,23.86l-.77.17c-.2.04-.38-.14-.38-.39v-1.99c0-.25.18-.43.38-.39l.77.17c.15.03.27.2.27.39v1.65c0,.19-.11.35-.27.39Z"
        fill="#7b8291"
      />
      <polygon
        points="23.92 28.48 22.34 9.68 23.88 6.47 25.43 9.68 23.92 28.48"
        fill="#7b8291"
      />
      <path
        d="M35.71,30.01v2.72c0,2.81-1.69,5.28-4.13,6.06l-1.42.45c-.48.15-.98.23-1.48.23h-9.63c-.5,0-1-.08-1.48-.23l-1.42-.45c-2.44-.78-4.12-3.25-4.12-6.06v-12.04c0-.53.42-.95.95-.95h.31v9.33c0,.21.12.41.31.5l4.69,2.43h11.15l4.69-2.43c.19-.1.31-.29.31-.5v-9.33h.31c.53,0,.95.42.95.95v9.32h.01Z"
        fill="#7b8291"
      />
      <rect
        x="18.69"
        y="32.65"
        width="10.32"
        height="6.16"
        rx="0.39"
        ry="0.39"
        fill="#9aa2b5"
      />
      <path
        d="M17,38.35l-.66-.34c-1.89-1-3.08-2.96-3.08-5.1v-2.19c0-.22.24-.37.44-.26l3.93,2.06c.15.08.25.24.25.41v4.89c0,.45-.48.74-.88.53Z"
        fill="#9aa2b5"
      />
      <path
        d="M30.71,38.35l.66-.34c1.89-1,3.08-2.96,3.08-5.1v-2.22c0-.21-.22-.35-.41-.25l-3.95,2.08c-.15.08-.25.24-.25.41v4.89c0,.45.48.74.88.53Z"
        fill="#9aa2b5"
      />
    </g>
  </AvatarArtwork>
);

export default AvatarArtworkIronGiant;
